import React, { useState, useEffect, useRef } from 'react';
import { Groupledgers} from '../store/slices/ledger';
import Loader from '../common/Loader';
import { useDispatch} from 'react-redux';
import Table from '../common/Table';
import AdminLayout from './AdminLayout';
import { FaFileExcel } from 'react-icons/fa';
import { GroupLedgers } from '../common/ExcelDownload';
import { toast } from 'react-hot-toast';
import { useParams ,useNavigate} from 'react-router-dom';

const Ledgersgroup = () => {
  const dispatch = useDispatch();
  const tableRef = useRef(null);
    const { groupname } = useParams();
      const navigate = useNavigate();

    // console.log(groupname)

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;

  const [isLoading, setIsLoading] = useState(false);
  const [invoicelist, setInvoicelist] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]); // Stores selected row IDs
  const [selectAll, setSelectAll] = useState(false);
  const [columns, setColumns] = useState([
    { header: 'Checkbox', field: 'Checkbox' },
    { header: 'Ledger Name', field: 'ledger_name' },
    { header: 'Group Name', field: 'group_name' },
    // { header: 'Opening Balance', field: 'balance_combined' },
    { header: 'Closing Balance', field: 'closing_combined' },
    { 
      header: 'Actions', 
      field: 'actions', 
      isAction: true, 
      actionButtons: [
        { name: 'View Ledger Entries', className: 'btn-default' }, 
      ]
    }
  ]);

  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [totalPendingAmount, setTotalPendingAmount] = useState(0);
  const [totalPaidAmount, setTotalPaidAmount] = useState(0);


 // Load saved financial year and dates from localStorage
const loadSavedDates = () => {
  const savedFinancialYear = localStorage.getItem('selectedFinancialYear');
  
  // Ensure financial year is always correctly structured
  let startYear, endYear;
  if (savedFinancialYear && savedFinancialYear.includes('-')) {
    [startYear, endYear] = savedFinancialYear.split('-');
  } else {
    // Default to the current financial year
    const currentYear = new Date().getFullYear();
    startYear = currentYear - 1; // Example: 2024 (for 2024-2025)
    endYear = currentYear;       // Example: 2025 (for 2024-2025)
  }

  return {
    financialYear: savedFinancialYear || `${startYear}-${endYear}`,
    fromDate: localStorage.getItem('savedFromDate') || `${startYear}-04-01`,
    toDate: localStorage.getItem('savedToDate') || `${endYear}-03-31`,
    minDate: `${startYear}-04-01`,
    maxDate: `${endYear}-03-31`,
  };
};

// console.log(loadSavedDates())
const { fromDate: initialFromDate, toDate: initialToDate, minDate, maxDate, financialYear: initialFinancialYear } = loadSavedDates();

const [fromDate, setFromDate] = useState(initialFromDate);
const [toDate, setToDate] = useState(initialToDate);
const [financialYear, setFinancialYear] = useState(initialFinancialYear);


useEffect(() => {
  if (!financialYear) return;

  localStorage.setItem('selectedFinancialYear', financialYear);

  let startYear, endYear;
  if (financialYear.includes('-')) {
    [startYear, endYear] = financialYear.split('-');
  } else {
    return; // Exit if financial year is not valid
  }

  const savedFromDate = localStorage.getItem('savedFromDate') || `${startYear}-04-01`;
  const savedToDate = localStorage.getItem('savedToDate') || `${endYear}-03-31`;

  setFromDate(savedFromDate);
  setToDate(savedToDate);

  if (!localStorage.getItem('savedFromDate')) localStorage.setItem('savedFromDate', savedFromDate);
  if (!localStorage.getItem('savedToDate')) localStorage.setItem('savedToDate', savedToDate);
}, [financialYear]);




  const fetchLedgerGroup = async () => {
    setIsLoading(true);
    const params = {
      profile_id:id,
      from_date:fromDate,
      to_date:toDate,
      ledger_group_name:groupname,
    };
    // console.log(params)
    try {
      const data = await dispatch(Groupledgers(params)).unwrap();
      setIsLoading(false);
      setInvoicelist(data?.data);
          // Calculate total pending amount
    const pendingAmount = data?.data?.reduce(
      (sum, invoice) => sum + (parseFloat(String(invoice.opening_balance).replace(/,/g, "")) || 0), 
      0
    );
    
    const paidAmount = data?.data?.reduce(
      (sum, invoice) => sum + (parseFloat(String(invoice.closing_balance).replace(/,/g, "")) || 0), 
      0
    );
    
    setTotalPendingAmount(pendingAmount);
    setTotalPaidAmount(paidAmount)
    } catch (error) {
      setIsLoading(false);
      setInvoicelist([]);
      console.log('Error fetching invoices:', error.message);
    }
  };

  useEffect(() => {
    fetchLedgerGroup();
  }, [financialYear]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };


  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    fetchLedgerGroup();
  };

  const filtereditemList = invoicelist?.filter(
    (party) =>
      party?.ledger_id?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.ledger_name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.group_name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.opening_balance?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.closing_balance?.toString()?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  const handleView = (item) => {
    navigate(`/ledgerdetails/${item?.ledger_id ? item?.ledger_id : null}`)
 };


  const handleExcelDownload = () => {
    const selectedInvoices = selectAll ? invoicelist.map((invoice) => invoice.id) : selectedRows;

    if (!selectedInvoices || selectedInvoices.length === 0) {
      alert('Please select at least one Group Ledger.');
      return;
    }

    const selectedData = invoicelist.filter((invoice) => selectedInvoices.includes(invoice.id));

    if (selectedData.length === 0) {
      alert('No matching Group Ledgers found.');
      return;
    }

    try {
      GroupLedgers(selectedData, 'GroupLedgers.xlsx');
      toast.success('Downloading Excel file successfully!');
    } catch (error) {
      console.error('Error downloading Excel file:', error);
      alert('Failed to download the Excel file. Please try again.');
    }
  };




 // Handle date changes with validation
 const handleFromDateChange = (e) => {
  const newDate = e.target.value;
  if (newDate >= minDate && newDate <= maxDate) {
    setFromDate(newDate);
    localStorage.setItem('savedFromDate', newDate);
  } else {
    toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
  }
};

const handleToDateChange = (e) => {
  const newDate = e.target.value;
  if (newDate >= minDate && newDate <= maxDate) {
    setToDate(newDate);
    localStorage.setItem('savedToDate', newDate);
  } else {
    toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
  }
};

const formatFinancialYear = (startDate, endDate) => {
  return `(${startDate.split("-").reverse().join("-")} to ${endDate.split("-").reverse().join("-")})`;
};

const formatAmount = (value) => {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};
  return (
    <AdminLayout>
      {isLoading && <Loader />}
      <div className="row content-body">
        <div className="container-fluid">
          <div className="page-header">
            <div>
              <h2 className="main-content-title tx-24 mg-b-5">Group Ledgers</h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">Reports</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                Group Ledgers List
                </li>
              </ol>
            </div>
            <div className="d-flex justify-content-end">
          
              <button className="btn ripple btn-default" onClick={handleExcelDownload}>
                Export Excel <FaFileExcel />
              </button>
            </div>
          </div>

          <div class="row mb-4">
            <div class="col-md-12">
              <div class="card custom-card">
                <div class="card-body">
                  <form onSubmit={handleFilterSubmit} className="row mb-4">
                    <div className="col-md-3">
                      <label>From Date</label>
                      <input type="date" className="form-control" value={fromDate} onChange={handleFromDateChange} min={minDate} max={maxDate} />
                    </div>
                    <div className="col-md-3">
                      <label>To Date</label>
                      <input type="date" className="form-control" value={toDate} onChange={handleToDateChange} min={minDate} max={maxDate} />
                    </div>
                    <div className="col-md-3 mt-2">
                      <button type="submit" className="btn btn-default mt-4">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Table
                columns={columns}
                data={filtereditemList}
                tableRef={tableRef}
                pageSize={pageSize}
                setPageSize={setPageSize}
                currentPage={currentPage}
                totalCount={filtereditemList?.length}
                onPageChange={handlePageChange}
                handleSearchChange={handleSearchChange}
                handleView={handleView}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                selectAll={selectAll}
                setSelectAll={setSelectAll}
                totalPendingAmount={formatAmount(totalPendingAmount)}
                totalPaidAmount={formatAmount(totalPaidAmount)}
                totalfor={true}
              />
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default Ledgersgroup;
